export default __webpack_public_path__ + "static/media/ilya-yakover.988ba85b.jpg";